import sixByNineOct from './images/6x9 oct.png';
import nineByNineOct from './images/9x9x1 oct.png';
import tenInPlate from './images/10in plate.png';
import fiveByFive from './images/5x5.png';
import nineByNine3 from './images/9x9x3 clamshell.png';
import round16oz from './images/16oz round.png';
import round8oz from './images/8oz round.png';
import pleatedCup16 from './images/16oz pleated cup.png';
import boat32oz from './images/32oz boat.png';
import sixByNine from './images/6x9.png';

export const SKU_DATA = [
  { id: 50, value: '6x9 oct', label: '6x9 Octagonal Container', img: sixByNineOct },
//   { id: 3, value: '6x9', label: '6x9 Container', img: sixByNine },
  { id: 48, value: '9x9x1 oct', label: '9x9x1 Octagonal Container', img: nineByNineOct },
//   { id: 15, value: '10in plate', label: '10in Plate', img: tenInPlate },
//   { id: 2,  value: '5x5', label: '5x5 Container', img: fiveByFive },
//   { id: 49, value: '9x9x3 clamshell', label: '9x9x3 Clamshell', img: nineByNine3 },
//   { id: 1,  value: '16oz round', label: '16oz Round Bowl', img: round16oz },
//   { id: 14, value: '8oz round', label: '8oz Round Bowl', img: round8oz },
//   { id: 41, value: '16 pleated cup', label: '16oz Pleated Cup', img: pleatedCup16 },
//   { id: 112, value: '32oz boat', label: '32oz Boat', img: boat32oz },
  { id: 999, value: 'Unknown', label: 'Not Sure / Other', img: null }
];

export function getSkuById(id) {
  return SKU_DATA.find(sku => sku.id === Number(id)) || SKU_DATA.find(s => s.value === 'UNKNOWN');
}

export const LOCATION_NAMES = {
  a8bd83598299512e: 'Juicy',
  '92c96d949b682752': 'Choolaah',
  '8d0332fe8f757cb5': 'Mod Market',
  '702b187614f8b81e': 'Halal Shack',
};

export function getLocationName(locationId) {
  if (!locationId) return '-';
  return LOCATION_NAMES[locationId] || locationId;
}